













































































































































































































import { Component } from "vue-property-decorator";
import { VFields } from "@/models/v-fields";
import { Base } from "@/components/common/base";
import { storeService } from "@/shared";
import { vehicleInventoryService } from "@/shared";
import { PaginationModel, VHeaders } from "@/models/pagedlistmodel";
import { IDialogOption } from "@/models/dialog";
import { mapGetters } from "vuex";

@Component({
  props: ["methodName", "progress"],

  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ sourceStoreName: "getStoreName" }),
  },
  components: {
    Stores: () => import("@/components/common/store.select.vue"),
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
  },
})
export default class VehicleWholeSaleTransferPage extends Base {
    public form: any = {};
    public disableSubmitButton: boolean = false;
    public selectedStore: any;
    public selectedSaleType: any;
    public currentUserStoreId: number = 1;
    public isStoreLoading: boolean = false;
    public stores: any[] = [];
    public loading: boolean = false;
    public vehicleLoading: boolean = true;
    public journalAccountingTransactionList: any[] = [];
    public inboundAccountingTransactionList: any[] = [];
    public inboundStoreList: any;
    public saleType: any[] = [];
    public showSaleType: boolean = false;
    public showStore: boolean = false;
    public showDateFeild: boolean = false;
    public showSaleAmountFeild: boolean = false;
    public inboundList: any[];
    public vehicleLookupInventoryAccount: string;
    public vehicleLookupCost: string;
    public franchiseStores: any[] = [];
    public selectedFranchiseStore: any;
    public showFranchiseStore: boolean = false;
    public selectedFranchiseStoreDeatails: any;
    public showSubmitButton: boolean = false;
    public currentVehicleDetails: any;
    public vehicleSaleAccount: any;
    public vehicleReceivableAccount: string;
    public vehicleSalePayableAccount: string;
    public isValidVehicleResponse: boolean;
    public listItemId: string;
    public sourceStoreName: string;
    public inboundStoreName: string;
    public isStockLoading: boolean = false;
    public submitLoading: boolean = false;
    public menu: boolean = false;
    public created(): void {
        this.currentUserStoreId = this.userSession.storeId;
    }

  public pagination = new PaginationModel("date", true);

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }

  public callMethod(methodName): void {
    if (methodName === "backToList") {
      this.$router
        .push({
          name: "app.vehiclewholesale",
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "0",
      type: "button",
      title: this.$parent.$t("stores.btnBackToStoreTitle"),
      visible: true,
      class: "btn",
      label: this.$parent.$t("stores.btnBack"),
      click: "backToList",
      icon: "fas fa-arrow-left",
    });
    this.$emit("updateToolBar", buttons);
  }

  public async mounted() {
    // Toolbar
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.$watch(
      () => this.vehicleWholeSaleTransferFormModel.date,
      (newVal, oldVal) => {
        if (newVal) {
          this.setList();
        }
      }
    );

    this.getStores();

    this.vehicleWholeSaleTransferFormModel.date = this.presentDate();
  }
  public confirmSubmitDetails: IDialogOption = {
    width: 400,
    title: "Confirm?",
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: "Confirm",
      disable: false,
    },
  };

  public vehicleWholesaleTransferColumns: VHeaders[] = [
    {
      text: "Journal",
      align: "center",
      value: "Journal",
      sortable: false,
    },
    {
      text: "Account",
      align: "center",
      value: "Account",
      sortable: false,
    },
    {
      text: "Description",
      align: "center",
      value: "Description",
      sortable: false,
    },

    {
      text: "Date ",
      align: "center",
      value: "Date",
      sortable: false,
    },
    {
      text: "Control Number",
      align: "center",
      value: "ControlNumber",
      sortable: false,
    },
    {
      text: "Amount ",
      align: "center",
      value: "Amount",
      sortable: false,
    },
  ];

  public vehicleInboundColumns: VHeaders[] = [
    {
      text: "Journal",
      align: "center",
      value: "Journal",
      sortable: false,
    },
    {
      text: "Account",
      align: "center",
      value: "Account",
      sortable: false,
    },
    {
      text: "Description",
      align: "center",
      value: "Description",
      sortable: false,
    },

    {
      text: "Date ",
      align: "center",
      value: "Date",
      sortable: false,
    },
    {
      text: "Control",
      align: "center",
      value: "ControlNumber",
      sortable: false,
    },
    {
      text: "Amount ",
      align: "center",
      value: "Amount",
      sortable: false,
    },
  ];

  public vehicleWholeSaleTransferFormModel = {
    stockNumber: "",
    make: "",
    model: "",
    vin: "",
    vehicleCost: "",
    saleAmount: "",
    date: "",
  };

  public async getStores(): Promise<void> {
    try {
      this.isStoreLoading = true;
      const response = await storeService.getStoresList();

      var indexToRemove = response.results.findIndex(
        (item) => item.id == this.currentUserStoreId.toString()
      );
      if (indexToRemove !== -1) {
        response.results.splice(indexToRemove, 1);
      }
      this.stores = response.results;
    } finally {
      this.isStoreLoading = false;
    }
  }

  public async GetVehicleWholeSaleAccounts(): Promise<void> {
    try {
      this.isStoreLoading = true;
      const response = await storeService.GetVehicleWholeSaleAccounts(
        this.currentUserStoreId
      );

      if (response.vehicleSaleAccountSetupJson.length > 0) {
        this.saleType = response.vehicleSaleAccountSetupJson;
        this.vehicleReceivableAccount = response.vehicleReceivableAccount;
        this.vehicleSalePayableAccount = response.vehicleSalePayableAccount;
      }
    } finally {
      this.isStoreLoading = false;
      this.showSaleType = true;
      this.showStore = true;
      this.showDateFeild = true;
      this.showSaleAmountFeild = true;
    }
  }

  public async GetVehicleSaleGroupAccountsByStoreId(
    selectedStoreId
  ): Promise<void> {
    try {
      this.isStoreLoading = true;

      const response =
        await vehicleInventoryService.GetVehicleSaleGroupAccountsByStoreId(
          Number(selectedStoreId)
        );

      let res = this.stores.filter((store) => store.id == this.selectedStore);
      this.inboundStoreName = res[0].dealershipName;

      let data = response.vehicleSaleGroup;
      if (data && data.length > 0) {
        data.forEach((franchise) => {
          franchise.franchiseDescription =
            franchise.franchiseCode + " - " + franchise.franchiseDescription;
        });
      }
      this.franchiseStores = data;
      this.showFranchiseStore = true;
    } catch (ex) {
      this.showFranchiseStore = false;
      this.selectedFranchiseStore = "";
      this.showSubmitButton = false;
    } finally {
      this.isStoreLoading = false;
    }
  }

  public async fetchVehicleDetails() {
    if (this.vehicleWholeSaleTransferFormModel.stockNumber) {
      this.showSaleAmountFeild = false;
      this.journalAccountingTransactionList = [];
      this.isValidVehicleResponse = false;

      this.vehicleWholeSaleTransferFormModel.make = "";
      this.vehicleWholeSaleTransferFormModel.model = "";
      this.vehicleWholeSaleTransferFormModel.vehicleCost = "";
      this.vehicleWholeSaleTransferFormModel.vin = "";
      this.vehicleWholeSaleTransferFormModel.saleAmount = "";
      this.selectedSaleType = "";
      this.vehicleLookupInventoryAccount = "";
      this.vehicleLookupCost = "";
      try {
        this.isStockLoading = true;
        this.disableSubmitButton = true;
        this.$emit("update:progress", this.disableSubmitButton);
        this.loading = true;
        const response = await vehicleInventoryService.FindVehicleDetails(
          this.vehicleWholeSaleTransferFormModel.stockNumber
        );

        if (response.model) {
          this.currentVehicleDetails = response;
          this.vehicleWholeSaleTransferFormModel.make = response.make;
          this.vehicleWholeSaleTransferFormModel.model = response.model;
          this.vehicleWholeSaleTransferFormModel.vehicleCost =
            response.vehicleCost;
          this.vehicleWholeSaleTransferFormModel.vin = response.vin;
          this.vehicleLookupInventoryAccount = response.inventoryAccount;
          this.vehicleLookupCost = response.vehicleCost;
          this.showSaleAmountFeild = true;
          this.isValidVehicleResponse = true;
          this.setList();
          this.GetVehicleWholeSaleAccounts();
        }
      } catch (ex) {
        console.log(ex);
        this.showSaleAmountFeild = false;
        this.journalAccountingTransactionList = [];
        this.isValidVehicleResponse = false;

                this.vehicleWholeSaleTransferFormModel.make = "";
                this.vehicleWholeSaleTransferFormModel.model = "";
                this.vehicleWholeSaleTransferFormModel.vehicleCost = "";
                this.vehicleWholeSaleTransferFormModel.vin = "";
                this.vehicleLookupInventoryAccount = "";
                this.vehicleLookupCost = "";

            } finally {
                this.disableSubmitButton = false;
                this.$emit("update:progress", this.disableSubmitButton);
                this.isStockLoading = false;
                this.loading = false;
            }
        }
    }

  public async submitDetails(): Promise<void> {
    if (
      !this.vehicleWholeSaleTransferFormModel.stockNumber ||
      this.vehicleWholeSaleTransferFormModel.stockNumber == ""
    ) {
      this.showAlert(false, "Stock Number is required");
      return;
    }
    if (
      !this.vehicleWholeSaleTransferFormModel.make ||
      this.vehicleWholeSaleTransferFormModel.make == ""
    ) {
      this.showAlert(
        false,
        "Vehicle Make is required, Please Check Stock Number Again"
      );
      return;
    }
    if (
      !this.vehicleWholeSaleTransferFormModel.model ||
      this.vehicleWholeSaleTransferFormModel.model == ""
    ) {
      this.showAlert(
        false,
        "Vehicle Model is required, Please Check Stock Number Again"
      );
      return;
    }
    if (
      !this.vehicleWholeSaleTransferFormModel.vin ||
      this.vehicleWholeSaleTransferFormModel.vin == ""
    ) {
      this.showAlert(false, "VIN is required, Please Check Stock Number Again");
      return;
    }
    if (
      !this.vehicleWholeSaleTransferFormModel.vehicleCost ||
      this.vehicleWholeSaleTransferFormModel.vehicleCost == ""
    ) {
      this.showAlert(
        false,
        "Vehicle Cost is required, Please Check Stock Number Again"
      );
      return;
    }
    if (
      !this.vehicleWholeSaleTransferFormModel.saleAmount ||
      this.vehicleWholeSaleTransferFormModel.saleAmount == ""
    ) {
      this.showAlert(false, "Sale Amount is required");
      return;
    }
    if (!this.selectedStore || this.selectedStore == "") {
      this.showAlert(false, "Please select a store");
      return;
    }
    if (!this.selectedFranchiseStore || this.selectedFranchiseStore == "") {
      this.showAlert(false, "Please select a franchise");
      return;
    }
    if (
      !this.vehicleWholeSaleTransferFormModel.date ||
      this.vehicleWholeSaleTransferFormModel.date == ""
    ) {
      this.showAlert(false, "Please choose a date");
      return;
    }

    this.confirmSubmitDetails.model = true;
    this.confirmSubmitDetails.onAction = () => {
      this.confirmSubmitDetails.model = false;

      this.submitData();
    };
    }

  public async submitData() {
    let cuurentStoreId = this.currentUserStoreId.toString();
    try {
      this.loading = true;
      this.submitLoading = true;
      this.isStoreLoading = true;
      this.disableSubmitButton = true;
      this.$emit("update:progress", this.disableSubmitButton);

      var response = await vehicleInventoryService.submitVehicleTransfer(
        this.currentVehicleDetails,
        this.journalAccountingTransactionList,
        this.selectedFranchiseStoreDeatails,
        cuurentStoreId,
        this.selectedStore,
        this.sourceStoreName,
        this.inboundStoreName,
        this.vehicleWholeSaleTransferFormModel.saleAmount,
        this.vehicleReceivableAccount,
        this.vehicleWholeSaleTransferFormModel.date,
        this.vehicleSaleAccount[0].id,
        this.vehicleSaleAccount[0].saleType,
        this.vehicleSaleAccount[0].saleAccount,
        this.vehicleSaleAccount[0].costOfSaleAccount
      );

      if (response.status) {
        this.showAlert(true, response.response);

        this.showSaleAmountFeild = false;
        this.selectedSaleType = "";
        this.showFranchiseStore = false;
        this.journalAccountingTransactionList = [];
        this.vehicleWholeSaleTransferFormModel.stockNumber = "";
        this.vehicleWholeSaleTransferFormModel.date = "";
        this.vehicleWholeSaleTransferFormModel.make = "";
        this.vehicleWholeSaleTransferFormModel.model = "";
        this.vehicleWholeSaleTransferFormModel.vehicleCost = "";
        this.vehicleWholeSaleTransferFormModel.vin = "";
        this.selectedStore = "";
        this.selectedFranchiseStore = "";
        this.isStoreLoading = false;

        this.$router.push({
          name: "app.vehiclewholesale",
        });
      } else {
        if (!response.response)
          this.showAlert(false, "Failed to transfer vehicle.");
        else this.showAlert(false, response.response);
      }
    } finally {
      this.loading = false;
      this.submitLoading = false;
      this.isStoreLoading = false;
      this.vehicleWholeSaleTransferFormModel.date = this.presentDate();
      this.$emit("update:progress", this.loading);
      this.disableSubmitButton = false;
      this.$emit("update:progress", this.disableSubmitButton);
    }
  }
  public GetSelectStore() {
    this.GetVehicleSaleGroupAccountsByStoreId(Number(this.selectedStore));
  }

  public setList() {
    if (!this.isValidVehicleResponse) {
      this.journalAccountingTransactionList = [];
    } else {
      if (this.saleType && this.saleType.length > 0) {
        this.vehicleSaleAccount = this.saleType.filter(
          (item) => item.id === this.selectedSaleType
        );
      }
      if (
        this.vehicleSaleAccount &&
        this.vehicleSaleAccount.length > 0 &&
        this.showSaleAmountFeild
      ) {
        this.journalAccountingTransactionList = [
          {
            Account: this.vehicleSaleAccount[0].saleAccount ?? "N/A",
            Description:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Date: this.vehicleWholeSaleTransferFormModel.date ?? "N/A",
            ControlNumber:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Amount:
              this.vehicleWholeSaleTransferFormModel?.saleAmount != null
                ? `-${this.vehicleWholeSaleTransferFormModel.saleAmount}`
                : "N/A",
            Journal: "VSU",
          },
          {
            Account: this.vehicleSaleAccount[0].costOfSaleAccount ?? "N/A",
            Description:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Date: this.vehicleWholeSaleTransferFormModel.date ?? "N/A",
            ControlNumber:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Amount: this.vehicleLookupCost ?? "N/A",
            Journal: "VSU",
          },
          {
            Account: this.vehicleLookupInventoryAccount ?? "N/A",
            Description:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Date: this.vehicleWholeSaleTransferFormModel.date ?? "N/A",
            ControlNumber:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Amount:
              this.vehicleLookupCost != null
                ? "-" + this.vehicleLookupCost
                : "N/A",
            Journal: "VSU",
          },
          {
            Account: this.vehicleReceivableAccount ?? "N/A",
            Description:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Date: this.vehicleWholeSaleTransferFormModel.date ?? "N/A",
            ControlNumber:
              this.vehicleWholeSaleTransferFormModel.stockNumber ?? "N/A",
            Amount: this.vehicleWholeSaleTransferFormModel.saleAmount ?? "N/A",
            Journal: "VSU",
          },
        ];
      }
    }
  }

  public async fetchInboundList() {
    this.inboundStoreList =
      await vehicleInventoryService.getVehicleTransferDetailById(
        this.listItemId
      );
    if (this.inboundStoreList) {
      this.setViewFeilds();
      this.GetVehicleSaleGroupAccountsByStoreId(Number(this.selectedStore));
    }
  }

  public selectFranchise() {
    this.showSubmitButton = true;
    const data = this.franchiseStores.filter(
      (item) => item.franchiseCode === this.selectedFranchiseStore
    );
    if (data && data.length > 0) this.selectedFranchiseStoreDeatails = data[0];
  }

  public setViewFeilds() {
    this.vehicleWholeSaleTransferFormModel.stockNumber =
      this.inboundStoreList.vehicleDetails.stockNumber;
    this.vehicleWholeSaleTransferFormModel.model =
      this.inboundStoreList.vehicleDetails.model;
    this.vehicleWholeSaleTransferFormModel.make =
      this.inboundStoreList.vehicleDetails.make;
    this.vehicleWholeSaleTransferFormModel.saleAmount =
      this.inboundStoreList.saleAmount;
    this.vehicleWholeSaleTransferFormModel.vin =
      this.inboundStoreList.vehicleDetails.vin;
    this.vehicleWholeSaleTransferFormModel.date =
      this.inboundStoreList.transactionDate;
    this.vehicleWholeSaleTransferFormModel.vehicleCost =
      this.inboundStoreList.vehicleDetails.vehicleCost;
    this.selectedStore = this.inboundStoreList.inboundStoreId;
    this.selectedFranchiseStore =
      this.inboundStoreList.vehicleSaleGroup.franchiseCode;
    if (this.inboundStoreList.vehicleSaleAccountSetup) {
      this.saleType = this.inboundStoreList.vehicleSaleAccountSetup;
      this.vehicleReceivableAccount =
        this.inboundStoreList.vehicleReceivableAccount;
      this.vehicleSalePayableAccount =
        this.inboundStoreList.vehicleSalePayableAccount;
    }

    this.selectedSaleType = this.inboundStoreList.vehicleSaleAccountSetup.id;
    this.selectedStore = this.inboundStoreList.inboundStoreId;
    this.inboundStoreList.sourceStoreAccountingDetail.forEach((item) => {
      this.journalAccountingTransactionList.push({
        Account: item.account ?? "N/A",
        Description: item.description ?? "N/A",
        Date: item.date ?? "N/A",
        ControlNumber: item.controlNumber ?? "N/A",
        Amount: item.amount,
        Journal: "VSU",
      });
    });

    this.inboundStoreList.inboundStoreAccountingDetail.forEach((item) => {
      this.inboundAccountingTransactionList.push({
        Account: item.account ?? "N/A",
        Description: item.description ?? "N/A",
        Date: item.date ?? "N/A",
        ControlNumber: item.controlNumber ?? "N/A",
        Amount: item.amount ?? "N/A",
        Journal: item.journal ?? "N/A",
      });
    });
  }
}
